// extracted by mini-css-extract-plugin
export default {"container":"adminsys-layout_container__AABQB","menubar":"adminsys-layout_menubar__jr0tv"};